var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayersTwo01 = function SvgLayersTwo01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m2 14.5 9.642 4.821c.131.066.197.098.266.111q.091.018.184 0c.069-.012.135-.045.266-.11L22 14.5m-20-5 9.642-4.821c.131-.066.197-.099.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 9.5l-9.642 4.821a1 1 0 0 1-.266.111.5.5 0 0 1-.184 0c-.069-.013-.135-.045-.266-.11z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgLayersTwo01;